import React from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

const Loader = (props) => {
  const { colour, height } = props;
  const width = height;

  return (
    <div className="loader" style={{ width, height }} role="presentation">
      <div className="loader-circle loader-circle-one" style={{ backgroundColor: colour }} role="presentation" />
      <div className="loader-circle loader-circle-two" style={{ backgroundColor: colour }} role="presentation" />
      <div className="loader-circle loader-circle-three" style={{ backgroundColor: colour }} role="presentation" />
      <div className="loader-circle loader-circle-four" style={{ backgroundColor: colour }} role="presentation" />
    </div>
  );
};

Loader.propTypes = {
  colour: PropTypes.string,
  height: PropTypes.string
};

Loader.defaultProps = {
  colour: '#d5d5d5',
  height: '50px',
};

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Loader/Loader.js
 **/